module.exports = __webpack_public_path__ + "static/img/bl.fdf67c59.jpeg";